import { useState } from "react";
import { useStore } from "zustand";
import type { TeleopSession } from "../modules/teleop-session";

export function ControlAccessPanel({ session }: { session: TeleopSession }) {
  const status = useStore(session, (s) => s.controlAccess);
  const [key, setKey] = useState("");
  if (!status || status === "local") return null;
  return <section aria-label="Доступ к удалённому управлению">
    <strong>Доступ к управлению: {status === "authorized" ? "подтверждён" :
      status === "pending" ? "проверка ключа" : status === "rejected" ? "не подтверждён" : "закрыт"}</strong>
    {status !== "authorized" && <form onSubmit={(event) => {
      event.preventDefault();
      session.authorizeControl(key);
      setKey("");
    }}>
      <label>Ключ Panther <input type="password" value={key} autoComplete="off"
        spellCheck={false} onChange={(event) => setKey(event.target.value)} /></label>
      <button type="submit" disabled={status === "pending" || !key}>Подтвердить доступ</button>
    </form>}
    <p>Компьютер и Quest подтверждают доступ отдельно. После переподключения введите ключ снова и выберите источник управления.</p>
  </section>;
}
